import { useState } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import 'jspdf-autotable'
import authService from "../../../api-authorization/AuthorizeService";
import { generateReportPDF } from "./GeneratePdf";

import AddOatsDiseaseMeasures from "../../measures/oats/addOatsDiseaseMeasures";

const SummaryReport = (props) => {
    const [reportName, setReportName] = useState("");
    const [email, setEmail] = useState("");
    const [buttonText, setButtonText] = useState("Download PDF report");
    const [isEmailChecked, setIsEmailChecked] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!reportName) {
            toast.error("Please input a report name", {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                theme: "colored",
            }); return
        };
        if (isEmailChecked && !email) {
            toast.info("Please input a valid email", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                theme: "colored",
            });
            return
        };

        let county = props.farmData.address && props.farmData.address.county;

        let pdfReport = generateReportPDF({ reportName, farmName: props.farmData.name, surveyYear: props.surveyData.year, userEmail: props.userEmail, basisNumber: props.basisNumber, listOfCrops: props.listOfCrops, listOfOtherCrops: props.listOfOtherCrops, sbiNumber: props.farmData.sbiNumber, county });
        let toastText = "Report created";
        if (isEmailChecked) {
            toast.info("Sending email...", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                theme: "colored",
            });
            const formData = new FormData();
            formData.append("recipientEmail", email);
            formData.append("file", new Blob([pdfReport], { type: "application/pdf" }), `${reportName}.pdf`);
            let response = await sendReport(formData);
            if (!response.ok) {
                toast.error("Error sending email", {
                    position: "top-right",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    progress: undefined,
                    theme: "colored",
                });
                return;
            }
            toastText = "Report created and sent by email";
        }
        toast.success(toastText, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "colored",
        });
        return;
    }
    const handleEmailCheckboxChange = async (e) => {
        if (e.target.checked) {
            setButtonText("Download and send PDF report by email");
            setIsEmailChecked(true);
            return;
        }
        setButtonText("Download PDF report");
        setIsEmailChecked(false);
    }

    async function sendReport(formData) {
        try {
            const token = await authService.getAccessToken();
            const response = await fetch("/api/survey/send-report", {
                method: "POST",
                headers: !token ? {} :
                    {
                        'Accept': "application/json",
                        'Authorization': `Bearer ${token}`
                    },
                body: formData,
            });
            return await response;
        } catch (error) {
            console.error("Error:", error);
        }
    }






    return (
        <>
            <h2 className="font-weight-bold mt-3">
                <u>Get a report of your IPM Plan</u>
            </h2>
            <Form onSubmit={handleSubmit}>
                <Row className="align-items-center">
                    <Col xs="auto">
                        <FloatingLabel controlId="reportNameField"
                            label="Report Name"
                            className="mb-3">
                            <Form.Control
                                className="mb-2"
                                placeholder="My Report"
                                value={reportName}
                                maxLength={60}
                                onChange={(e) => setReportName(e.target.value)} />
                            <Form.Text className="text-muted">
                                {reportName.length}/60 characters
                            </Form.Text>
                        </FloatingLabel>
                    </Col>
                    <Col xs="auto">
                        <Form.Check
                            type="checkbox"
                            id="autoSizingCheck"
                            className="mb-2"
                            label="Send by email"
                            onChange={handleEmailCheckboxChange}
                        />
                    </Col>
                    <Col xs="auto" style={{ display: isEmailChecked ? "block" : "none" }}>
                        <InputGroup className="mb-2">
                            <InputGroup.Text>@</InputGroup.Text>
                            <Form.Control id="userEmailTextInput"
                                placeholder="Email recipient"
                                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                required={isEmailChecked}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)} />
                        </InputGroup>
                    </Col>
                    <Col xs="auto">
                        <Button type="submit" className="mb-2">
                            {buttonText}
                        </Button>
                    </Col>
                </Row>
            </Form >
        </>
    );
};

export default SummaryReport;